import ApiService from '@shared/services/api.service';

const endPoint = '/contact_groups';

const ContactGroupService = {
  getList() {
    return ApiService.get(endPoint);
  },

  create(bodyParams) {
    return ApiService.post(`${endPoint}`, bodyParams);
  },

  update(group, bodyParams) {
    return ApiService.put(`${endPoint}/${group}`, bodyParams);
  },

  get(group) {
    return ApiService.get(`${endPoint}/${group}`);
  },

  delete(group) {
    return ApiService.delete(`${endPoint}/${group}`);
  }
};
export default ContactGroupService;
